// extracted by mini-css-extract-plugin
export default {"headerBar":"PJ-z","pointsSection":"QJ-z","goToDashboard":"RJ-z"};